// Display scale (Salem 2026-09-27: "the UI should adapt to the screen resolution / size of the
// monitor — I always zoom out to 80% on my laptop").
//
// styles.css sets `html { zoom: var(--ui-zoom) }`. Since the design system (4 Oct 2026) the
// automatic steps are gone — the fluid grid fits a laptop on its own — and "Auto" means 100%.
// A person can still pin a smaller size; that choice lives on <html data-scale="…"> and in
// localStorage so it paints before the first render, like the theme.
//
// Two things in the browser are NOT scaled by zoom — getBoundingClientRect() / event clientX/Y
// (screen px) and window.innerWidth/innerHeight — while every layout length (style.left, widths,
// fixed-position offsets) is in scaled "layout px". Code that mixes the two divides the screen
// value by uiZoom() first. Everything else (media queries, ResizeObserver, offsetWidth) is fine.

export const SCALES = [
  { id: "auto", name: "Auto — the grid fits this screen (100%)" },
  { id: "100", name: "100% — larger" },
  { id: "90", name: "90%" },
  { id: "85", name: "85%" },
  { id: "80", name: "80% — compact" },
];

const KEY = "repiq_scale";

export function applyScale(id) {
  const root = document.documentElement;
  if (id && id !== "auto") root.setAttribute("data-scale", id);
  else root.removeAttribute("data-scale");
  try { localStorage.setItem(KEY, id || "auto"); } catch { /* ignore */ }
}

export function storedScale() {
  try { return localStorage.getItem(KEY) || "auto"; } catch { return "auto"; }
}

/** The effective page zoom (1 when unscaled or when the browser has no `zoom`). */
export function uiZoom() {
  if (typeof document === "undefined") return 1;
  const z = parseFloat(getComputedStyle(document.documentElement).zoom);
  return z > 0 ? z : 1;
}

/** Screen px (a client rect, clientX) → layout px (what style.left / top / width expect). */
export function toLayout(px) { return px / uiZoom(); }

/** The viewport size in layout px — use instead of window.innerWidth / innerHeight when
 *  comparing with element sizes or positioning a fixed element. */
export function layoutViewport() {
  const z = uiZoom();
  return { w: window.innerWidth / z, h: window.innerHeight / z };
}
